import Vue from "vue"
import Vuetify from 'vuetify/lib'

import 'vuetify/src/styles/main.sass'

Vue.use(Vuetify)

const options = {}

export default new Vuetify(options)